module.exports = __webpack_public_path__ + "static/542641.jpg";